export default "__VITE_ASSET__Ce8kpAat__"